
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { getDepartmentList } from '@/api/company';
import { getDealOrderUser, getEngineerList } from '@/api/users';
@Component({
  name: 'selectPolling',
  components: {

  }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })dialogSelectEngineer!:Boolean;

  // 1 客服 2 工程师
  @Prop({
    type: Number,
    default: ''
  })pollingType!:Number;
  @Prop({
    type: Array,
    default: () => []
  })selectEng!:any;

  private deptData:any = []
  private current = ''
  private serviceData:any = []
  private serviceChecked:any = ''
  private engineerIdChecked:any=[]
  private engineerChecked:any= []
  private engineerData:any = []

  private defaultImgUrl = require('@/assets/images/default-avatar.png')

  created() {
    if (this.pollingType === 2) {
      this.current = 'eng';
      this.getEngineerList('');
    } else {
      this.current = 'self';
      this.serviceData = [{
        account: { mobile: UserModule.getAccountMobile },
        user: {
          name: UserModule.getUserName,
          head_img: UserModule.getHeadPic,
          id: UserModule.getUserId

        }
      }];
    }
    this.getDept();
  }
  private getDept() {
    let params:any = {
      company_id: UserModule.getCompanyId,
      user_id: UserModule.getUserId,
      type: '9', // type=9 查所有部门  type=2查服务部门
      dept_type:2,
      page: 1,
      size: 999
    };
    getDepartmentList(params)
      .then(res => {
        if (res.data) {
          this.deptData = res.data.list;
        }
      })
      .catch(err => {
        let msg = err.msg;
      });
  }
  // private isActive:number=1
  private dept:any={}

  private selectServiceSelf() {
    this.current = 'self';
    this.dept = {};
    this.serviceData = [{
      account: { mobile: UserModule.getAccountMobile },
      user: {
        name: UserModule.getUserName,
        head_img: UserModule.getHeadPic,
        id: UserModule.getUserId
      }

    }];
  }
  private selectServiceAll() {
    this.current = 'all';
    this.dept = {};
    this.getDealOrderUser(null);
  }
  private selectDept(val: any) {
    this.dept = val;
    if (this.pollingType === 1) {
      this.getDealOrderUser(val.id);
    } else {
      this.getEngineerList(val.id);
    }
  }
  private getDealOrderUser(deptId:any) {
    let params:any = {
      company_id: UserModule.getCompanyId,
      user_id: UserModule.getUserId
    };
    if (deptId) {
      params.dept_id = deptId;
    }
    getDealOrderUser(params).then(res => {
      if (res.data) {
        this.serviceData = res.data.list;
      } else {
        this.serviceData = [];
      }
    });
  }
  private serviceChange(val:any) {
    if (this.dept && this.dept.id) {
      this.serviceChecked.dept_id = this.dept.id;
      this.serviceChecked.dept_name = this.dept.name;
    }
  }
  private selectEngineerAll() {
    this.current = 'eng';
    this.dept = {};
    this.getEngineerList('');
  }
  private getEngineerList(deptId:any) {
    let params:any = {
      company_id: UserModule.getCompanyId,
      user_id: UserModule.getUserId
    };
    if (deptId) {
      params.department_id = deptId;
    } else {
      this.engineerIdChecked = []
      this.engineerChecked = []
    }
    getEngineerList(params).then(res => {
      if (res.data) {
        this.engineerData = res.data.list;
        // this.setEngSelected();
      } else {
        this.engineerData = [];
      }
    });
  }
  private setEngSelected() {
    if (this.selectEng && this.selectEng.length > 0) {
      for (let index = 0; index < this.selectEng.length; index++) {
        const element = this.selectEng[index];
        let arr = this.engineerChecked.filter((e:any) => {
          return e.user_id === element.user_id;
        });
        if (!arr || arr.length < 1) {
          this.engineerIdChecked.push(element.user_id);
          this.engineerChecked.push(element);
        }
      }
    }
  }

  private checkboxEngineer(check:boolean, val: any) {
    if (check) {
      if (this.dept && this.dept.id) {
        val.dept_id = this.dept.id;
        val.dept_name = this.dept.name;
      }
      let arr1 = this.engineerChecked.filter((e:any) => {
        return (!val.dept_id || e.dept_id === val.dept_id);
      });
      if (!arr1 || arr1.length < 1) {
        this.engineerChecked = []
        this.engineerIdChecked = []
      }
      this.engineerIdChecked.push(val.user_id)
      this.engineerChecked.push(val);
    } else {
      let index = -1;
      for (let i = 0; i < this.engineerChecked.length; i++) {
        const element = this.engineerChecked[i];
        if (val.user_id === element.user_id) {
          index = i;
          break;
        }
      }
      this.engineerIdChecked.splice(index, 1);
      this.engineerChecked.splice(index, 1);
    }
  }
  private selectFinish() {
    if (this.pollingType === 2) {
      let selectData:any = {};
      if ((!this.engineerChecked || this.engineerChecked.length < 1)) {
        selectData.isDept = true;
        selectData.engList = [];
        selectData.servicer_dept_id = this.dept.id;
        selectData.servicer_dept_name = this.dept.name;
        this.$emit('engineerChecked', selectData);
      } else {
        selectData.isDept = false;
        selectData.servicer_dept_id = this.dept.id;
        selectData.servicer_dept_name = this.dept.name;
        selectData.engList = this.engineerChecked;
        this.$emit('engineerChecked', selectData);
      }
      this.close();
    } else {
      this.$emit('serviceChecked', this.serviceChecked);
    }
  }

  private close() {
    this.$emit('close', false);
  }
}

